import React, { Component} from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { Card, CardText, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { connect } from "react-redux";
import { history } from "../../_helpers"
import { userActions } from "../../_actions";
import { SlButton, SlBusyIndicator, TextInput, SlRadioButton, MfaCodeEntry, SlYesNo } from '../editors';
import validator from 'validator';
import { metadataService, userService, AccountAPI } from '../../_services';
import { ServiceUtil as serviceUtil } from '../../_services/services.util';
import { Banner } from './Banner';


class LogIn extends Component {
  static displayName = LogIn.name;
  constructor(props) {
    super(props);

      if (this.props.currentAction !== userService.ACTION_SHOW_EMAIL_IN_USE
          && this.props.currentAction !== userService.ACTION_SHOW_RECAPTCHA_FAILED
          && this.props.currentAction !== userService.ACTION_USER_HASH_IN_USE
              ) {
          this.props.dispatch(userActions.logout());
      }
    
    var isFromSignUp = window.location.href.toLowerCase().endsWith('signuplogin');
    this.state = {
      email: "",
      password: "",
      submitted: false, 
      isFromSignUp, 
      mfaOption: 'email', 
      mfaStep: 0, 
      mfaToken: "", 
      mfaSentMessage: "", 
      mfaCode: ['',''], 
      saveDevice: "true",
      banner: ""
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSendMfaCode = this.handleSendMfaCode.bind(this);
    this.handleMfaBack = this.handleMfaBack.bind(this);
    this.mfaValueUpdated = this.mfaValueUpdated.bind(this);
    this.handleValidateMfa = this.handleValidateMfa.bind(this);
    this.doLogin = this.doLogin.bind(this);
    this.loadBanner = this.loadBanner.bind(this);

      document.addEventListener('language', () => {
          this.loadBanner();
      });
    }

    componentDidMount() {
        this.loadBanner();
    }

    loadBanner() {
        serviceUtil.getHomeBanner().then(bannerResponse => {
            this.setState({ banner: bannerResponse });
        });
    }

  handleSendMfaCode(){
    const { dispatch } = this.props;
    dispatch(userActions.sendDeviceAuthCode(this.state.email,
      this.state.mfaOption === "email" ? AccountAPI.MFA_TARGET_EMAIL : AccountAPI.MFA_TARGET_TEXT )); 
  }

  handleMfaBack(){
    const { dispatch } = this.props;
    dispatch(userActions.getDeviceAuthCode())
  }
  mfaValueUpdated(newMfaValue){
    this.setState({mfaCode:newMfaValue});
 }

  handleValidateMfa(){
    const mfaRequest = {
      tokenId: this.props.deviceTokenId,
      codeParts: this.state.mfaCode,
      reason: 0
    }
    this.doLogin(mfaRequest, this.state.saveDevice === 'true');
  }
  handleChange(e) {
    
    const { name, value } = e.target;
    const fieldName = metadataService.jsonFieldName(name);
    var newState = {[fieldName] : value}
    var finalState = {...this.state, ...newState};

    this.setState({
      [fieldName]: value,
      canLogIn: this.isLoginValid(finalState.email, finalState.password)
    });
  }

  isLoginValid(email, password) {
    if ((email + "").length > 5 && (password + "").length > 5) {
      const isEmail = validator.isEmail(email + "");
      const isEmpty = validator.isEmpty(password + "");
      //const isPass = zxcvbn(password);
        return isEmail && !isEmpty; // && isPass.score > 2;
    }
    return false;
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    this.doLogin(); 
  }
  doLogin(mfaRequest, saveDevice){
    const { email, password } = this.state;
    const { dispatch } = this.props;
    if (email && password) {
        dispatch(userActions.login(email, password, mfaRequest, saveDevice));
        serviceUtil.getBanner();

    }
  }
  handleSignup(e) {
    history.push("/SignUpCustomerStatus");
  }
  getErrorMessageByCurrentAction(currentAction){
      switch (currentAction) {
          case userService.ACTION_AUTH_DEVICE_CODE:
              return metadataService.getMessage("InvalidAuthenticationCode");
          case userService.ACTION_SHOW_EMAIL_IN_USE:
              return metadataService.getMessage("EmailInUsePleaseLogin");
          case userService.ACTION_SHOW_RECAPTCHA_FAILED:
              return metadataService.getMessage("ReCaptchaFailed");
          case userService.ACTION_USER_HASH_IN_USE:
              return metadataService.getMessage("UserHashMatchFound");
          default:
              return metadataService.getMessage("LoginFailed");
      }
  }
  render() {
    const { loggingIn, error } = this.props;
    const { email, password } = this.state;
    return (
      <div className="LogIn">
        
            {this.state.banner.showBanner && (
                <Banner text={this.state.banner.text} type={this.state.banner.type}></Banner>
            )}
            {error && (
                <Row className="justify-content-center">
                    <Col xs={12} md={6}>
                      <Alert color="danger" style={{ margin: "0px", lineHeight: "1.2em" }}>
                            { this.getErrorMessageByCurrentAction(this.props.currentAction) }
                      </Alert>
                    </Col>
                </Row>
          )}
       
            {(this.props.currentAction === userService.ACTION_LOGIN ||
                this.props.currentAction === userService.ACTION_SHOW_EMAIL_IN_USE ||
                this.props.currentAction === userService.ACTION_USER_HASH_IN_USE) && (
          <React.Fragment>
            <Row className="justify-content-center">
              <SlBusyIndicator visible={loggingIn} />
              {!loggingIn && (
                <Col xs={12} md={6}>
                  <Card>
                    {this.state.isFromSignUp && (
                      <CardHeader>
                        {metadataService.getLabel("SignUpLabel")}
                      </CardHeader>
                    )}
                    <CardBody>
                      <TextInput
                        name="Email"
                        value={email}
                        onChange={this.handleChange}
                      />
                      <TextInput
                        name="Password"
                        type="password"
                        value={password}
                        onChange={this.handleChange}
                      />
                      <Row
                        className="text-center"
                        style={{ margin: "18px 0px 28px 0px" }}
                      >
                        <Col>
                          <SlButton
                            name="SignIn"
                            onClick={this.handleSubmit}
                            disabled={!this.state.canLogIn}
                          />
                        </Col>
                      </Row>
                      {!this.state.isFromSignUp && (
                        <Row>
                          <Col>
                            <CardBody className="text-center noPadTop noPadBottom forgotPassword">
                              <Link to="/ForgotPassword">
                                {metadataService.getButton("ForgotPassword")}
                              </Link>
                            </CardBody>
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              )}
            </Row>

            {!loggingIn && !this.state.isFromSignUp && !this.props.loginHash && (
                <div>
                    <Row className="justify-content-center">
                        <Col>
                            <hr style={{ marginTop: "0", marginBottom: "0", width: "80%" }}/>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">              
                        <Col xs={12} md={6}>
                            <Card>
                            <CardBody className="noPadBottom">
                                <Row>
                                <Col style={{ margin: "18px 0px 28px 0px" }}>                          
                                    <CardBody className="noPadTop noPadBottom text-center">
                                        <div style={{color: "#21409a", fontSize: "22px"}}>{metadataService.getTitle("SignUpSection")}</div>
                                        <div style={{color: "#21409a", fontSize: "22px"}}>{metadataService.getTitle("SignUpSectionBottom")}</div>
                                    </CardBody>
                                    <div className="text-center">
                                    <SlButton
                                        name="SignUp"
                                        cssClass="backBtn"
                                        onClick={this.handleSignup}
                                    />
                                    </div>
                                </Col>
                                </Row>
                            </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
        )}
          </React.Fragment>
        )}
        {this.props.currentAction === userService.ACTION_AUTH_DEVICE && (
            <Card>
              <CardBody>
              
                <Row style={{ marginBottom: "20px" }}>
                  <Col className="text-center">
                    {metadataService.getMessage("UnregisteredDevice", metadataService.maskEmail(email))}
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <SlYesNo
                    name="saveDevice"
                    onChange={this.handleChange}
                    labelName="RememberDevice"
                    value={this.state.saveDevice}
                    trueValue="true"
                    falseValue="false"
                    trueText={metadataService.getLabel("Yes")}
                    falseText={metadataService.getLabel("No")}
                  />
                </Row>
                <Row className="justify-content-center">
                  <SlButton
                    name="Next"
                    onClick={this.handleSendMfaCode}
                  />
                </Row>
              </CardBody>
            </Card>
          )}
        {this.props.currentAction === userService.ACTION_AUTH_DEVICE_CODE && (
            <Card>
              <CardHeader>
                <SlButton name="Back" cssClass="backBtn" onClick={this.handleMfaBack} />
              </CardHeader>
              <CardBody>
                <MfaCodeEntry
                  message={this.state.mfaSentMessage}
                  value={this.state.mfaCode}
                  valueUpdated={this.mfaValueUpdated}
                  onSubmit={this.handleValidateMfa}
                  onReSend={this.handleSendMfaCode}
                />
              </CardBody>
            </Card>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { loggingIn, error, currentAction, deviceTokenId } = state.authentication;
    const { loginHash } = state.users;
    
    const { language } = state.users;

    return {
        loggingIn, error, currentAction , deviceTokenId, language,loginHash};
}

const connectedLoginPage = connect(mapStateToProps)(LogIn);
export { connectedLoginPage as LogIn };